import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";
import Cash from "../Pages/Cash";
import Companies from "../Pages/Companies";
import Tickets from "../Pages/Tickets";
import Anpr from "../Pages/Anpr";
import InOut from "../Pages/InOut";
import CC from "../Pages/CC";
import Sessions from "../Pages/Sessions";
import Backups from "../Pages/Backups";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import CompaniesOptions from "../Pages/CompaniesOptions";
import ResumeDay from "../Pages/ResumeDay";
import Stats2 from "../Pages/Stats2";
import Estadisticas from "../Pages/Estadisticas";
import Tarifario from "../Pages/Tarifario";
import PermisosOperadores from "../Pages/PermisosOperadores";
import Informes from "../Pages/Informes";
import AccesosMonitor from "../Pages/AccesosMonitor";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard />, title: "Inicio" },

  { path: "/customers", component: <Cash />, title: "Caja" },
  { path: "/tickets", component: <Tickets />, title: "Tickets" },
  { path: "/anpr", component: <Anpr />, title: "Capturas ANPR" },
  { path: "/inout", component: <InOut />, title: "Entradas y Salidas" },
  { path: "/opers", component: <Cash />, title: "Caja" },
  // Una sola entrada de menu: `Estadisticas` elige que pantalla mostrar
  // segun la version del Desktop del cliente. Ver Pages/Estadisticas.
  { path: "/stats", component: <Estadisticas />, title: "Estadísticas" },
  // Vista alternativa en pruebas. La de arriba no se toca.
  // Fuera del menu: acceso directo a la nueva, para soporte.
  { path: "/stats2", component: <Stats2 />, title: "Estadísticas" },
  { path: "/tarifario", component: <Tarifario />, title: "Tarifario" },
  { path: "/permisos-operadores", component: <PermisosOperadores />, title: "Permisos de Operadores" },
  { path: "/informes", component: <Informes />, title: "Informes" },
  { path: "/accesos", component: <AccesosMonitor />, title: "Accesos a Monitor" },
  { path: "/cash", component: <Cash />, title: "Caja" },
  { path: "/companies", component: <Companies />, title: "Estacionamientos" },
  { path: "/cc", component: <CC />, title: "Mensuales" },
  { path: "/sessions", component: <Sessions />, title: "Sesiones" },
  { path: "/backups", component: <Backups />, title: "Backups" },
  { path: "/resumeDay", component: <ResumeDay />, title: "Resumen Diario" },

  { path: "/companiesOptions", component: <CompaniesOptions />, title: "Mis Estacionamientos" },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
